import { gql, useQuery } from '@apollo/client'
import { useMemo } from 'react'

import {
  ItemResaleRaffleUserDetailFragmentDoc,
  PaymentDetailFragmentDoc,
  ResaleRaffleRepaymentCompletionQuery,
  ResaleRaffleRepaymentCompletionQueryVariables,
} from '@/clients/utoniq-core/schema'
import { useRouter } from '@/core'
import { makeViewModel } from '@/core/architecture'
import { setItemSku } from '@/core/sku'

import { Action, State } from './template'

/**
 *
 */
export const useViewModel = makeViewModel<State, Action>(() => {
  const { router } = useRouter<{ itemId: string; raffleId: string }>()
  const { raffleId, itemId } = router.query

  const { data, loading } = useQuery<
    ResaleRaffleRepaymentCompletionQuery,
    ResaleRaffleRepaymentCompletionQueryVariables
  >(QUERY, {
    variables: {
      raffleId,
      itemId,
    },
  })

  const itemResaleRaffleUser = useMemo(() => {
    if (!data?.itemResaleRaffleUser) {
      return null
    }
    return {
      ...data?.itemResaleRaffleUser,
      item: setItemSku(
        data?.itemResaleRaffleUser?.item,
        data?.itemResaleRaffleUser.skuId
      ),
    }
  }, [data?.itemResaleRaffleUser])

  return {
    state: {
      itemResaleRaffleUser,
      loading,
    },
    actions: {},
  }
})

const QUERY = gql`
  query ResaleRaffleRepaymentCompletion(
    $raffleId: ID!
    $itemId: String!
    $skuId: String
  ) {
    itemResaleRaffleUser(raffleId: $raffleId, itemId: $itemId) {
      ...ItemResaleRaffleUserDetail
    }
    paymentSource {
      ...PaymentDetail
    }
  }
  ${ItemResaleRaffleUserDetailFragmentDoc}
  ${PaymentDetailFragmentDoc}
`
